import { render, staticRenderFns } from "./CollectionSlotBody.vue?vue&type=template&id=5ffcca00&scoped=true&"
import script from "./CollectionSlotBody.vue?vue&type=script&lang=ts&"
export * from "./CollectionSlotBody.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionSlotBody.vue?vue&type=style&index=0&id=5ffcca00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcca00",
  null
  
)

export default component.exports